export default __webpack_public_path__ + "assets/heart.8664a3d5.png";